export const SKYSCANNER_VIEW_ID = 'X-Skyscanner-ViewId';
